import { _, Backbone, moment } from "../../../../vendor";
import { Notification, Biscuit } from "../../../utils";
import InboomaBaseView from "../../InboomaBaseView";
import InboomaBaseCollectionView from "../../InboomaBaseCollectionView";
import "../../../../vendor/Blob";
import { S3Client } from "aws_js";
import * as FileSaver from "../../../../vendor/FileSaver";

import PaginationBehavior from "../../../behaviors/Behavior.Pagination";

import SalesBillingsItemTpl from "../../../templates/orders/SalesBillings/SalesBillingsItemTpl.html";

const SalesBillingView = InboomaBaseView.extend({
  template: SalesBillingsItemTpl,
  className: "inb-c-item-details-row inb-c-item--sales-billings row",

  ui: {
    removeSalesBilling: ".inb-sales-billings-remove",
    readFile: "#readFile",
  },

  events: {
    "click @ui.removeSalesBilling": "_removeSalesBilling",
    "click @ui.readFile": "_readFile",
  },

  templateContext: {
    moment,
  },

  _readFile() {
    const file_name = this.model.get("file");

    S3Client.getDocument(
      Number(Biscuit.get("user.client_id")),
      "SalesBilling",
      this.model.get("location_id"),
      file_name,
    )
      .then((data) => {
        const blob = new Blob([data.Body], { type: data.ContentType });
        FileSaver.saveAs(blob, file_name.replace(/_/gi, " "));
      })
      .catch((err) => {
        alert(`Error downloading file: ${err}`);
      });
  },

  _removeSalesBilling(ev) {
    ev.preventDefault();

    const that = this;

    let rights = {
      user: 0,
      manager: 0,
      admin: 2,
    };

    const role = Biscuit.get("user.role");

    if (rights[role] > 0) {
      if (confirm(this.t("really_remove"))) {
        this.model.destroy({
          success: function (model, repsonse) {
            that.$el.fadeOut("fast");
            new Notification({
              message: that.t("removed_${a}", { a: that.t("sales_billing") }, "capital"),
              duration: 5000,
              closeable: true,
              icon: "fi fi-trash",
            });
          },
        });
      }
    } else {
      new Notification({
        message: that.t("cannot_remove_${a}", { a: that.t("sales_billing") }, "capital"),
        duration: 5000,
        closeable: true,
        icon: "fi fi-trash",
      });
    }
  },
});

export default InboomaBaseCollectionView.extend({
  childView: SalesBillingView,
  template: _.noop,

  behaviors: [
    {
      behaviorClass: PaginationBehavior,
    },
  ],

  initialize() {
    InboomaBaseCollectionView.prototype.initialize.apply(this);
    if (!this.options.widgetMode) {
      this.$el.html("");
    }

    this.render();
  },
});
